import { stockApi } from '$api'
import { Tender } from '$models'
import { singletonQueryClient } from '$utils'
import { TenderReview } from '@loadedhub/loaded-stock-api-sdk'
import { Dayjs } from 'dayjs'

export enum QueryKeys {
  Tenders = 'tenders',
  Tender = 'tender',
  TenderReview = 'tenderReview',
}

export const getTenders = async (): Promise<Tender[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.Tenders],
    queryFn: async () => {
      const tenders = await stockApi.getTenders()
      return tenders
    },
  })
}

export const getTender = async (id: string): Promise<Tender> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.Tender, id],
    queryFn: async () => {
      const tender = await stockApi.getTender(id)
      return tender
    },
  })
}

export const createTender = async (tender: Tender): Promise<Tender> => {
  const created = await stockApi.createTender(tender)
  singletonQueryClient.invalidateQueries({ queryKey: [QueryKeys.Tenders] })
  return created
}

export const updateTender = async (tender: Tender): Promise<Tender> => {
  if (!tender.id) {
    return Promise.reject(new Error('Tender ID is required for update'))
  }

  const updatedTender = await stockApi.updateTender(tender.id, tender)
  singletonQueryClient.invalidateQueries({ queryKey: [QueryKeys.Tenders] })
  singletonQueryClient.invalidateQueries({
    queryKey: [QueryKeys.Tender, tender.id],
  })
  return updatedTender
}

export const deleteTender = async (id: string): Promise<void> => {
  if (!id) {
    return Promise.reject(new Error('Tender ID is required for deletion'))
  }

  await stockApi.deleteTender(id)
  singletonQueryClient.invalidateQueries({ queryKey: [QueryKeys.Tenders] })
  singletonQueryClient.invalidateQueries({ queryKey: [QueryKeys.Tender, id] })
}

export const reviewTender = async (
  id: string,
  startTime: Dayjs | undefined,
  endTime: Dayjs | undefined,
  includeCredits: boolean
): Promise<TenderReview> => {
  return stockApi.getTenderReview(id, startTime, endTime, !includeCredits)
}
